import React from 'react';
import { Row, Col } from 'antd';

import {
  TotalEarningIcon,
  TotalWaitlistValueIcon,
  TotalWaitlistIcon,
  TotalOpenApplicationsIcon,
} from 'components/common/SVGIcon';

import SummaryCard from 'components/common/SummaryCardCustom';
import { getApplicationsSummaryData } from 'redux/contacts/selectors';
import { useSelector } from 'react-redux';

const ApplicationsSummary = () => {
  const summaries = useSelector(getApplicationsSummaryData) || {};

  const applicationsSummary = [
    {
      title: 'contacts.applicationsSummary.openApplications',
      count: summaries.openApplications,
      IconComponent: TotalOpenApplicationsIcon,
    },
    {
      title: 'contacts.applicationsSummary.valueOfOpenApplications',
      count: summaries.openApplicationsValue,
      IconComponent: TotalEarningIcon,
      isPerAnnum: true,
    },
    {
      title: 'contacts.applicationsSummary.totalWaitlisted',
      count: summaries.waitListedApplications,
      IconComponent: TotalWaitlistIcon,
    },
    {
      title: 'contacts.applicationsSummary.waitlistValue',
      count: summaries.waitListedApplicationsValue,
      IconComponent: TotalWaitlistValueIcon,
      isPerAnnum: true,
    },
  ];

  return (
    <Row gutter={[25, 25]} className="py-16 px-20">
      {applicationsSummary.map((item, index) => (
        <Col xxl={6} xl={8} md={12} xs={24} key={String(index)}>
          <SummaryCard {...item} />
        </Col>
      ))}
    </Row>
  );
};

export default ApplicationsSummary;
